import fp from 'lodash/fp';
import { all, takeLatest } from 'redux-saga/effects';
import { configurations } from './configurations';

function* adminSagas() {
  yield all(
    fp.flow(
      fp.filter(
        ({ sagas }) => sagas
      ),
      fp.map(
        ({ name, sagas, action }) => {
          return takeLatest(action.task[name]().type, sagas)
        }
      )
    )(configurations)
  );
}

export default adminSagas;



// WEBPACK FOOTER //
// ./src/state/modules/task/sagas.js